import { BodyText, Button } from '@unmind/design-system';
import { rem } from 'polished';

import styled from 'styled-components';

export const TransparencyMessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 16px;
  margin-bottom: 100px;
`;

export const TransparencyMessageTextContainer = styled.div`
  position: relative;
  padding: ${rem(16)} 0;
`;

export const AcknowledgeButtonContainer = styled.div``;

export const AcknowledgeButton = styled(Button)`
  width: 100%;
`;

export const AcknowledgeButtonText = styled(BodyText).attrs(({ theme }) => ({
  sizes: [theme.typography.fontSizes.fontSize16],
  color: theme.colors.text.inverse,
}))`
  text-align: center;
`;

export const NovaDisclaimerContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.background.secondary};
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 24px;
`;

export const AssistantIconContainer = styled.div`
  justify-content: center;
`;
